import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  HTTP_METHOD,
  ProduktRequested,
  ProdukttabelleEnum,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { AnyAction } from 'redux';
import { call, put, takeEvery } from 'redux-saga/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { cancel } from '@redux-saga/core/effects';
import { InitialHealthStatusEntry } from '@ps20/bff-models';
import { CheckoutActions } from '../checkout.actions';

export enum HealthStatusListRequestActions {
  HEALTH_STATUS_LIST_DOG_CAT_REQUEST_SUCCESSFUL = 'HEALTH_STATUS_LIST_DOG_CAT_REQUEST_SUCCESSFUL',
  HEALTH_STATUS_LIST_HORSE_REQUEST_SUCCESSFUL = 'HEALTH_STATUS_LIST_HORSE_REQUEST_SUCCESSFUL',
  HEALTH_STATUS_LIST_DOG_CAT_REQUEST_FAILED = 'HEALTH_STATUS_LIST_DOG_CAT_REQUEST_FAILED',
  HEALTH_STATUS_LIST_HORSE_REQUEST_FAILED = 'HEALTH_STATUS_LIST_HORSE_REQUEST_FAILED',
}

export const HEALTH_STATUS_URL_DOG_CAT = '/privatschutz/api/healthStatus/dogCat';
export const HEALTH_STATUS_URL_HORSE = '/privatschutz/api/healthStatus/horse';

export function* watchHealthStatusListRequest() {
  yield takeEvery(
    GlobalActions.PRODUKT_REQUESTED,
    safeSaga(getHealthStatusListSaga, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    HealthStatusListRequestActions.HEALTH_STATUS_LIST_DOG_CAT_REQUEST_SUCCESSFUL,
    safeSaga(successCallbackDogCat, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    HealthStatusListRequestActions.HEALTH_STATUS_LIST_HORSE_REQUEST_SUCCESSFUL,
    safeSaga(successCallbackHorse, App.SHOP_CHECKOUT),
  );
}

export function* getHealthStatusListSaga(action: GlobalAction<ProduktRequested>) {
  if (action.payload.appId !== App.TKV_V2 || action.payload.healthStatusLoaded) {
    yield cancel();
  }
  const isHorse =
    action.payload.produkttabelle === ProdukttabelleEnum.TKV_V2_PFERD_OPSCHUTZ ||
    action.payload.produkttabelle === ProdukttabelleEnum.TKV_V2_PFERD_VOLLSCHUTZ;
  const url = isHorse ? HEALTH_STATUS_URL_HORSE : HEALTH_STATUS_URL_DOG_CAT;
  const successEvent = isHorse
    ? HealthStatusListRequestActions.HEALTH_STATUS_LIST_HORSE_REQUEST_SUCCESSFUL
    : HealthStatusListRequestActions.HEALTH_STATUS_LIST_DOG_CAT_REQUEST_SUCCESSFUL;
  const errorEvent = isHorse
    ? HealthStatusListRequestActions.HEALTH_STATUS_LIST_HORSE_REQUEST_FAILED
    : HealthStatusListRequestActions.HEALTH_STATUS_LIST_DOG_CAT_REQUEST_FAILED;
  const globalPut = GlobalPut.getInstance();
  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequest({
      appId: App.SHOP,
      method: HTTP_METHOD.GET,
      body: '',
      url,
      successEvent,
      errorEvent,
    }),
  );
}

export function* successCallbackDogCat(successAction: AnyAction) {
  const initialHealthStatusEntries = successAction.payload as InitialHealthStatusEntry[];
  yield put(new CheckoutActions().healthStatusListDogCatReceived(initialHealthStatusEntries));
}

export function* successCallbackHorse(successAction: AnyAction) {
  const initialHealthStatusEntries = successAction.payload as InitialHealthStatusEntry[];
  yield put(new CheckoutActions().healthStatusListHorseReceived(initialHealthStatusEntries));
}
